import { Component, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Router, NavigationEnd } from '@angular/router';
import { environment } from './../environments/environment';

// Plugins e Serviços
import { AndroidFullScreen } from '@awesome-cordova-plugins/android-full-screen/ngx';
import { Insomnia } from '@awesome-cordova-plugins/insomnia/ngx';
import { BatteryStatus } from '@awesome-cordova-plugins/battery-status/ngx';
import { StatusBar } from '@capacitor/status-bar';
import { register } from 'swiper/element/bundle';

// Serviços de Negócio
import { NavigationCursorService } from 'src/app/nav-overlay/navigation-cursor.service';
import { UserService } from './user/user.service';
import { ProfileService } from './profile/profile.service';
import { profilePresets } from './manual-settings/manual-settings.data';

register();

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  private fullscreenActivated = false;

  constructor(
    private navigationCursorService: NavigationCursorService,
    private platform: Platform,
    private insomnia: Insomnia,
    private batteryStatus: BatteryStatus,
    private androidFullScreen: AndroidFullScreen,
    private router: Router,
    private userService: UserService,
    private profileService: ProfileService,
  ) {
    this.setupLanguage();
    this.initializeApp();
  }

  private setupLanguage() {
    if (localStorage.getItem('Idiom-Config') === null) {
      const navLang = navigator.language;
      const idiom = navLang.includes('pt') ? 'Português' : 'English';
      localStorage.setItem('Idiom-Config', idiom);
    }
  }

  private isNativeRuntime(): boolean {
    return this.platform.is('capacitor') || this.platform.is('cordova');
  }

  private async tryEnterFullscreenWeb() {
    try {
      if (this.isNativeRuntime()) return;

      const el: any = document.documentElement;
      const isFs =
        document.fullscreenElement ||
        (document as any).webkitFullscreenElement ||
        (document as any).msFullscreenElement;

      if (!isFs) {
        const req =
          el.requestFullscreen ||
          el.webkitRequestFullscreen ||
          el.msRequestFullscreen;

        if (req) {
          await req.call(el);
        }
      }
    } catch (e) {
      console.log('Fullscreen Web blocked:', e);
    }
  }

  private enableFullscreenOnFirstInteraction() {
    if (this.fullscreenActivated) return;

    const activate = async () => {
      if (this.fullscreenActivated) return;

      await this.tryEnterFullscreenWeb();

      const isFsNow =
        document.fullscreenElement ||
        (document as any).webkitFullscreenElement ||
        (document as any).msFullscreenElement;

      if (isFsNow) {
        this.fullscreenActivated = true;

        window.removeEventListener('pointerdown', activate, true);
        window.removeEventListener('click', activate, true);
        window.removeEventListener('touchstart', activate, true);
        window.removeEventListener('keydown', activate, true);
      }
    };

    window.addEventListener('pointerdown', activate, true);
    window.addEventListener('click', activate, true);
    window.addEventListener('touchstart', activate, true);
    window.addEventListener('keydown', activate, true);
  }

  initializeApp() {
    this.platform.ready().then(async () => {
      if ((environment as any).appType === 'link') {
        const gazePreset = profilePresets.find(p => p.name === 'Rastreador Ocular WebCam');
        if (gazePreset) {
          this.profileService.profile = gazePreset;
          try {
            this.userService.activeProfile = 'default';
          } catch (e) {}
        }
      }

      // Plugins Nativos
      if (this.isNativeRuntime()) {
        await StatusBar.hide();
        this.insomnia.keepAwake().catch(err => console.log('Insomnia error:', err));
        this.androidFullScreen.immersiveMode();
      } else {
        // Web/PWA/desktop: fullscreen só funciona com gesto do usuário
        await this.tryEnterFullscreenWeb();
        this.enableFullscreenOnFirstInteraction();
      }

      // Reaplicar ao navegar
      this.router.events.subscribe(async (evt) => {
        if (evt instanceof NavigationEnd) {
          if (this.isNativeRuntime()) {
            this.androidFullScreen.immersiveMode().catch(() => {});
          } else {
            await this.tryEnterFullscreenWeb();
          }
        }
      });

      // Monitor de Bateria
      this.batteryStatus.onChange().subscribe(status => {
        console.log('Battery Level:', status.level);
      });
    });
  }

  async ngOnInit() {
    setTimeout(() => {
      const outlet = document.querySelector('ion-router-outlet');
      const hasContent = outlet && outlet.children.length > 0;

      if (!hasContent) {
        console.warn('Fallback: Tela preta detectada. Resetando navegação...');
        localStorage.removeItem('conversia_onboarding_complete');
        this.router.navigateByUrl('/link/onboarding');
      }
    }, 2500);
  }
}
